<template>
  <div class="user-details-experience-score-panel">
    <div class="experience-score-kpi">
      <div v-if="hasNoKpiData" class="no-data-message">
        No Data To Display
      </div>
      <v-progress-circular
        v-if="userExperienceScoreKpi"
        :value="scoreCompletion"
        color="#024ad8"
        :size="144"
        :width="10"
      >
        <div class="kpi">
          {{userExperienceScoreKpi.toLocaleString(undefined, {maximumFractionDigits: 1, minimumFractionDigits: 1})}}
        </div>
      </v-progress-circular>
    </div>
    <div class="highcharts-light experience-score-footer-graph">
      <div v-if="userExperienceScoreTrend.length > 1">
        <highcharts :options="chartOptions" ref="chartComponent"></highcharts>
      </div>
    </div>
  </div>
</template>

<script>
import Highcharts from 'highcharts';
import {Chart} from 'highcharts-vue';

export default {
  name: 'user-details-experience-score-panel',
  components: {
    highcharts: Chart
  },
  props: {
    userExperienceScoreKpi: {
      type: Number,
      default: () => {}
    },
    userExperienceScoreTrend: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    chartOptions: function() {
      return {
        chart: {
          styledMode: true,
          type: 'area',
          height: 80,
          style: {
            color: '#404E55',
            fontSize: '12px',
            fontFamily: '"Forma DJR UI", Arial, sans-serif',
            fontWeight: '600'
          },
        },
        title: {
          text: undefined
        },
        legend: {
          enabled: false
        },
        plotOptions: {
          series: {
            lineWidth: 0,
            opacity: .8,
            marker: {
              enabled: false
            }
          }
        },
        xAxis: {
          categories: this.userExperienceScoreTrend.map((data) => moment(data.periodStartDate).format('MMM D'))
        },
        yAxis: {
          min: 0,
          max: 10,
          tickInterval: 5,
          title: {
            text: undefined
          }
        },
        credits: {
          enabled: false
        },
        series: [{
          name: 'Experience Score',
          lineWidth: 0,
          data: this.userExperienceScoreTrend.map((data) => {
            return {name: moment(data.periodStartDate).format('LL'), y: data.aggregateFact}
          })
        }]
      };
    },
    hasNoKpiData: function() {
      return !this.userExperienceScoreKpi;
    },
    scoreCompletion: function() {
      return this.userExperienceScoreKpi * 10;
    }
  },
}
</script>

<style lang="scss" scoped>
.user-details-experience-score-panel {
  height: 100%;
  display: flex;
  flex-direction: column;
  .experience-score-header {
    color: var(--filter-text-color);
    font-size: 24px;
    font-weight: 800;

    .experience-score-header-flex-container {
      display: flex;

      div {
        flex: 2;
        line-height: 90%;
        padding-right: 8px;
      }

      .experience-score-arrows-img {
        width: 21px;
        height: 40px;
        flex: 1;
      }
    }
  }

  .experience-score-kpi {
    flex-grow: 1;
    max-width: 100%;
    max-height: 190px;
    display: flex;
    justify-content: center;
    align-items: center;
    .kpi {
      font-weight: 800;
      font-size: 56px;
      color: var(--text-color);
    }
  }

  .experience-score-footer-graph {
    width: 100%;
    height: auto;
    text-align: center;
    padding-top: 9px; // 6 below graph +  9 here = 15px total
  }
}
</style>
